import useWindowSize from 'components/util/useWindowSize'
import LeftRobotCard from 'components/cards/new/common/LeftRobotCard'

const features = [
  'Active and renewing subscriptions',
  'Client usage and post volumes',
  'Revenue insights by customer segment',
  'Exportable invoice and billing summaries',
]

const RealTimeMetricsAndReporting = () => {
  const size = useWindowSize()

  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm pointing right with scan background',
        desktop: {
          dimensions: {
            height: 569,
            width: 657,
          },
          src: '/images/new/au/robot-arm-pointing-right-scanbg.png',
        },
        mobile: {
          dimensions: {
            height: 307,
            width: 361,
          },
          src: '/images/new/au/robot-holding-phone-crop.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '50%' : '100%'}
      imageStyle={{
        objectFit: 'cover',
        objectPosition: 'right top',
        width: '100%',
      }}
      reverseColumnOrder
    >
      <div className='d-flex flex-1 flex-column px-4 pb-10 pe-lg-8 pt-6 py-lg-15'>
        <h3 className='fw-semibold fs-fluid-36-52 lh-105 mb-5 mb-lg-8'>
          <span className='color-pink2'>Real-Time </span>Metrics & Reporting
        </h3>
        <div className='d-flex flex-column gap-4'>
          <span className='fs-fluid-20-28 fw-lg-bold fw-semibold lh-114'>
            Stay in control with live dashboards showing:
          </span>
          {features.map((feature, index) => (
            <div className='fs-fluid-20-26 fw-semibold' key={index}>
              {feature}
            </div>
          ))}
        </div>
      </div>
    </LeftRobotCard>
  )
}

export default RealTimeMetricsAndReporting
